import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15c7a58f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-1 min-w-0 p-4"
}
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = { class: "subContext flex-1 mx-6" }
const _hoisted_4 = { class: "subButton flex items-center justify-between" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "flex justify-end" }
const _hoisted_7 = { class: "flex flex-col mx-8 py-6 dataAdjust" }
const _hoisted_8 = { class: "flex-1 center-plate" }
const _hoisted_9 = {
  key: 0,
  class: "mx-6"
}
const _hoisted_10 = {
  key: 0,
  class: "AdjustmentTips"
}
const _hoisted_11 = {
  key: 1,
  class: "px-6"
}
const _hoisted_12 = { class: "peopleTeam p-4 mx-6" }
const _hoisted_13 = { class: "peopleTeam-center" }
const _hoisted_14 = { class: "productionTimeValue font-medium text-center text-white" }
const _hoisted_15 = { class: "timeStep flex-1 my-6" }
const _hoisted_16 = { class: "font-medium markModel" }
const _hoisted_17 = {
  key: 0,
  class: "remarkItem"
}
const _hoisted_18 = {
  key: 1,
  class: "remarkItem"
}
const _hoisted_19 = {
  key: 2,
  class: "remarkItem"
}
const _hoisted_20 = {
  key: 3,
  class: "remarkItem"
}

import { api as viewerApi } from 'v-viewer'
import { onBeforeUnmount, onMounted, ref } from "vue";
import { IItemData } from './components/CompletionReport-2.vue';
import MessageShow from './components/MessageShow.vue';
//引入组件
import JListInfo from "@/components/jlist/index.vue"
import JText from "./components/j-text.vue";
import JText2 from "./components/j-text2.vue";
import JText3 from './components/j-text3.vue';
import titleButton from "./components/title-button.vue"
import JablilBtn from "./components/ablilit-btn.vue"
import jtabBar, { ITabsDataItem } from "@/components//jtabs-2/index.vue";
import JCompleteReport from "./components/CompletionReport-2.vue"
import titleRadio from "./components/title-radio.vue";
import configFiles from "./page/configFiles2.vue";
import timeStep from "./components/timeStep.vue";
import buttonStyle from "@/components/jslide-box/button/button2.vue"
//引入api
import { compareNumber } from "@/constant/index";
import API, { IPostMachineProductionGetCurProductionWorkOrderListVo, IPostMachineProductionGetInCountVo, IPostMachineProductionGetProducingProductionCountInfoByIdVo, IPostMachineProductionGetWorkOrderInfoByIdVo } from "@/api/machine/index";
import { IPostMachineProductionGetWorkOrderInfoByIdSonDataList, IPostMachineProductionMachineOperationCountReportInVo } from "@/api/machine/index.type.public";
import { cellModel } from "@/components/jslide-box/button/button-1.vue";
import { message, Modal } from "ant-design-vue";
import { throttle } from "@/utils/throTtle"
import { useStore } from "vuex";
//---------------------传入参数、回调、监听定义---------------------
//定义传入变量

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  workId: {
    required: false,
    type: Number,
  },
  realTimeData: {
    required: false,
    type: Object,
  },
},
  emits: ["switch"],
  setup(__props, { emit }: { emit: ({
  //切换选项卡
  (e: "switch", tabs: string, parm: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;




//定义回调事件


//定义生命周期事件
onMounted(() => {
  if (store.state.inforReport.statue) {
    visibleComplete.value = true
  }
  //生命周期处理内容
  getCurWorkOrderLIst()
  timer.value = setInterval(productionTime, 1000);
});

onBeforeUnmount(() => {
  clearInterval(timer.value)
  timer.value = null;
})
// ---------------------数据变量定义-------------------------
const store = useStore();

//变量定义
let workInfoList = ref<IPostMachineProductionGetWorkOrderInfoByIdVo[]>([])
//生产信息存放
let productionData = ref<IPostMachineProductionGetCurProductionWorkOrderListVo>({});

//更新数据存储  计划生产数 与 开始投料数
let productionNumberData = ref<IPostMachineProductionGetProducingProductionCountInfoByIdVo>({})

//仅完工时，做的最终调整结果---定时上报使用，实时调整使用
let productUpLoadData = ref<IPostMachineProductionMachineOperationCountReportInVo>({})

//最终完工上报上传的数据
let productFinshUpLoadData = ref<IPostMachineProductionMachineOperationCountReportInVo>({})
//获取投料数
let FeedingQuantity = ref<IPostMachineProductionGetInCountVo>({})
//上机人员
let machineTeam = ref<string>();

//当前是否在运行工单  true表示有单子在生产  false表示没有单子在生产
let curRunOrder = ref<boolean>(false);

//用于标记当前视图是否正在生产信息true
let curOrderStatus = ref<boolean>(false);

//当前生产订单的开始调机投料数
let debugStartOutCount = ref(0);
//当前生产订单的开始投料数
let startOutCount = ref(0);

//实时运转速度
let speed = ref(0)
//实时完成率
let realComplete = ref(0)

//计数器
let loopTime = ref<number>(0);
//定时器
let timer = ref();
//信息tab切换
let activeKey = ref();
//总投料数
const allQuantity = ref<number>(0)
//生产耗时
let productionTimeValue = ref<string>("00:00:00")
//接单调机修改数
const editdebugOutputAdjustment = ref<number>(0)
//接单调机正品数修改
const editdebugGoodput = ref<number>(0)
//预计耗时
let estimateTimeConsumingValue = ref<string>("00:00:00")

//用于展示当前页面的主工单编号
let showWorkId = ref<number>(props.workId);
//显示字段配置页面
const visibleConfigFiles = ref<boolean>(false);
const showConfigFilesId = ref<number>(-1);
const showConfigFilesTitle = ref<string>('');

//显示完工上报
const visibleComplete = ref<boolean>(false);
//完工上报后缺数二次弹框
const missReportComplete = ref<boolean>(false);
const radioChoose = ref<string>('y')
//异常跳转
const visibleError = ref<boolean>(false);
//前置工单
const visiblePrepose = ref<boolean>(false);
//备注显示弹框
const visiblemark = ref<boolean>(false);
//取消生产弹框
const cancelProductionShow = ref<boolean>(false);
//接单调剂提示
const visibleReceiving = ref<boolean>(false);
//接单调机调机数修改停止自动计算
const visibleReceivStatu = ref<boolean>(false);
let bannerList = ref<IPostMachineProductionGetWorkOrderInfoByIdVo>({})
//是否启动调机 true开启，false不开启
const needDebug = ref<boolean>(true)
//当前操作序列
const butCurOperation = ref<number>(0);
const butOperationList = ref<cellModel[]>([]);
const tabOperationList = ref<ITabsDataItem[]>([])
const curOperationOrder = ref<number>(0)
// ---------------------方法定义-------------------------
//打开配置信息
const onConfigFileds = (choose: IPostMachineProductionGetWorkOrderInfoByIdSonDataList) => {
  visibleConfigFiles.value = true;
  showConfigFilesId.value = choose.sonId;
  showConfigFilesTitle.value = choose.sonInfoTypeName;
}
//关闭配置信息
const onCloseConfigFileds = (state: "close" | "complent") => {
  visibleConfigFiles.value = false;
  if (state === 'complent') {
    //更新列表信息
    //获取工单配置字段和内容
    getWorkOrderInfoById(showWorkId.value)
  }
};
/**
 * 更新当前界面信息
 * @param orderId 订单id
 */
const updateCurPageInfo = (orderId: number) => {
  //获取操作信息
  // getOperationList(orderId);
  //获取工单配置字段和内容
  getWorkOrderInfoById(orderId)
  //获取右侧实时数据
  getProductionCountInfo(orderId);
  //获取班组信息
  getMachineTeam(orderId);

}
const viewer = ref(null)
//显示图片
const onShowImg = () => {
  if (productionData.value.imagesPath.length > 0) {
    //如果需要指定显示某一张图片使用view方法，index是指定的那张图片所在数组的位置索引
    viewerApi({
      // initialViewIndex:index,
      images: productionData.value.imagesPath
    })
  }
}
//显示备注
const onShowMark = () => {
  visiblemark.value = true
}
//取消生产
const cancelProduction = () => {
  if (productUpLoadData.value.goodOutput) {
    cancelProductionShow.value = true
  } else {
    onSureEnd()
  }
}
//取消生产弹框回调
const onCancelHandleOk = (status) => {
  cancelProductionShow.value = false
  if (status == 'cance') {
    onSureEnd()
  } else if (status == 'complete') {
    productFinshUpLoadData.value = JSON.parse(JSON.stringify(productUpLoadData.value))
    visibleComplete.value = true
  }
}
const onSureEnd = () => {
  API.postMachineProductionCancelWorkOrder(
    { workOrderId: String(showWorkId.value) }
  ).then(res => {
    message.success("已取消生产")
    //清除该工单的存储信息
    store.commit("inforReport/removeCombineProcedureList");
    store.commit("inforReport/removeKeepInforStatu", {});
    setTimeout(() => {
      emit("switch", "workOrder", "")
    }, 1000);
  })
}

//获取操作列表
const getOperationList = (orderId: number) => {
  API.postMachineProductionGetProcedureOperationListById({ id: orderId }).then((rep) => {
    curOperationOrder.value = rep.curOperationOrder
    butCurOperation.value = rep.curOperationOrder;
    needDebug.value = (rep.needDebug || rep.needDebug == false) ? rep.needDebug : true
    //进行数据集拆分 更新
    butOperationList.value = rep.operationVoList.map((e, index) => {
      let status = '';
      if (rep.curOperationOrder > e.order) {
        status = 'operation'
      } else if (rep.curOperationOrder === e.order) {
        status = 'hand'
      } else if (rep.curOperationOrder + 1 === e.order) {
        status = 'wait'
      } else if (rep.curOperationOrder < e.order) {
        status = 'disable'
      }
      return {
        id: e.id,
        status: status,
        name: e.name,
        code: e.order,
        operationTime: e.operationTime
      }
    })
    //不良品项拆分

    if (rep.canChoosePreWasteReasonList.length > 0) {
      rep.canChoosePreWasteReasonList.map(e => {
        if (!productUpLoadData.value.materialBadDetailList.some(item => item.code == e.propertyCode)) {
          productUpLoadData.value.materialBadDetailList.push(
            { code: e.propertyCode, label: e.propertyDesc, num: 0 }
          )
        }
      })
    }
  })
}
//获取上机人员
const getMachineTeam = (orderId: number) => {
  API.postMachineProductionGetMachineTeamInfoById({ id: orderId }).then((rep) => {
    machineTeam.value = "无"
    if (rep && rep.machineTeamUser) {

      let names = '';
      for (let index = 0; index < rep.machineTeamUser.length; index++) {
        const element = rep.machineTeamUser[index];
        names = names + "、" + element.employeesNmae;
      }
      if (names.length > 0) {
        machineTeam.value = names.substring(1)
      }
    }
  })
}

//获取工单配置字段和内容
const getWorkOrderInfoById = (orderId: number) => {
  if (showWorkId.value) {
    API.postMachineProductionGetWorkOrderInfoById({ id: orderId }).then((rep) => {
      if (rep.list.length > 0) {
        workInfoList.value = rep.list
        bannerList.value = workInfoList.value[0]
        tabOperationList.value = rep.list.map(e => {
          return {
            id: e.id,
            value: e.infoTypeName,
            select: false
          }
        })
        activeKey.value = tabOperationList.value[0].id
        showPageInfo(tabOperationList.value[0]);
      }
    })
  }
}
//刷新菜单显示内容
const showPageInfo = (item: ITabsDataItem) => {
  if (showWorkId.value) {
    for (let index = 0; index < workInfoList.value.length; index++) {
      // debugger;
      const element = workInfoList.value[index];
      if (element.id === item.id) {
        bannerList.value = element
        break;
      }
    }
  }
}
//获取生产实时数据
const getProductionCountInfo = (oneId: number) => {
  if (showWorkId.value) {
    API.postMachineProductionGetProducingProductionCountInfoById({ id: oneId }).then((e) => {
      productUpLoadData.value = {
        adjustmentReason: "",
        customOutput: 0,
        debugGoodOutputAdjustment: e.debugGoodOutput,
        debugOutputAdjustment: e.debugOutput,
        goodOutput: e.goodOutput,
        goodOutputAdjustment: e.adjustmentGoodOutput,
        materialBadOutput: e.materialBadOutput,
        workBadOutput: e.workBadOutput,
        //生产耗时
        productionTimeValue: e.endTime,
        productionRecordId: e.productionRecordId,
        //材废不良品项
        materialBadDetailList: [...e.materialBadDetailList]
      };
      getOperationList(oneId)
      // if (e.materialBadDetailList && e.materialBadDetailList.length > 0) {
      //   e.materialBadDetailList.map(item => {
      //     productUpLoadData.value.materialBadDetailList.push(item)
      //   })
      // }
      //调机阶段起始投料数
      debugStartOutCount.value = e.startDebugOutCount;
      //生产阶段投料数
      startOutCount.value = e.startProductionOutCount
      productionNumberData.value = e;
      //复位投料数
      //如果没有在生产状态，进行数据回显
      if (!curOrderStatus.value) {
        //完成率重新计算-----解决被初数为0问题
        if (productionNumberData.value.planOutput) {
          realComplete.value = Math.round((((productUpLoadData.value.goodOutput || 0) / productionNumberData.value.planOutput) * 100))
        } else {
          realComplete.value = 0;
        }
        //步长
        speed.value = 0;
        //投料数
        // productionNumberData.value.startDebugOutCount = e.productionInQty + e.debugInQty //上个版本bug
        allQuantity.value = e.productionInQty
        //调机调料数
        productUpLoadData.value.debugOutputAdjustment = e.debugInQty
        //生产耗时
        productionTimeValue.value = "00:00:00"
        //预计耗时
        estimateTimeConsumingValue.value = productionTimeValue.value;

        //预计耗时复合计算
        try {
          if (e.endTime) {
            let endTime = new Date(e.endTime);  //结束时间
            let startTime = new Date(e.productionStartTime); //开始时间
            let difftime = (endTime.getTime() - startTime.getTime()) / 1000; //计算时间差
            let hours = parseInt(difftime / 3600 + "");    // 小时 60*60 总小时数-过去的小时数=现在的小时数 
            let minutes = parseInt(difftime % 3600 / 60 + ""); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
            let seconds = parseInt(difftime % 60 + "");  // 以60秒为一整份 取余 剩下秒数
            //生产耗时
            productionTimeValue.value = compareNumber(hours) + ":" + compareNumber(minutes) + ":" + compareNumber(seconds)
            //预计耗时
            estimateTimeConsumingValue.value = productionTimeValue.value;
          }
        } catch (error) {
          console.error("结束时间和开始时间有问题，无法进行计算")
        }
      }
    })
  }
}
//投料数不一致弹框确认
const missComplete = (status: 'cance' | 'complete') => {
  missReportComplete.value = false
  if (status === 'complete') {
    endFinsh()
  }
}
let endCompetedata = ref<IPostMachineProductionMachineOperationCountReportInVo>({})
//完工数据上报
const onHandleOk = async (status: string, data: IItemData[], list, type: string, num: number | string) => {
  endCompetedata.value = JSON.parse(JSON.stringify(productUpLoadData.value))
  if (status === 'cance') {
    visibleComplete.value = false;
  } else {
    // 判定员工班组系数是否为100
    API.postMachineProductionGetUserPerformanceSum().then((rep) => {
      if (rep.sum != 100) {
        //缓存当前填报数据
        store.commit("inforReport/setKeepInforList", {
          inforList: data, wastList: list, statue: true,
          baseInfor: {
            planOutput: productionNumberData.value.planOutput,
            recordGoodNum: productFinshUpLoadData.value.goodOutput,
            isDebugGood: productionData.value.isDebugGood,
            debugOutputAdjustment: productFinshUpLoadData.value.debugOutputAdjustment,
            debugGoodOutputAdjustment: productFinshUpLoadData.value.debugGoodOutputAdjustment
          }
        });
        message.error("当前系数不正确，请先调整系数")
        emit("switch", "peopleTeam", true)
        return;
      }
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        endCompetedata.value[element.filed] = element.value
      }
      endCompetedata.value['isMissingNumber'] = type
      endCompetedata.value['isWebShallPrevail'] = ''
      endCompetedata.value['goodOutputAdjustment'] = endCompetedata.value['goodOutput'] - (Number(num) - productUpLoadData.value['goodOutputAdjustment'])
      endCompetedata.value.materialBadDetailList = list
      let paramObj = JSON.parse(JSON.stringify(endCompetedata.value))
      delete paramObj.materialBadDetailList
      API.postMachineProductionGetInCount({ id: butOperationList.value[butCurOperation.value].id, workOrderId: showWorkId.value, countReportInVo: paramObj }).then(e => {
        FeedingQuantity.value = e
        if (e.deviceId && e.webId && e.deviceId == e.webId) {
          endFinsh()
        } else {
          missReportComplete.value = true
          endCompetedata.value['isWebShallPrevail'] = 'y'
        }
      })
    })
  }
}
//获取投料数
//进行完工操作
const endFinsh = throttle(() => {
  //进行完工操作
  API.postMachineProductionMachineOperation({
    id: butOperationList.value[butCurOperation.value].id,
    workOrderId: showWorkId.value,
    countReportInVo: endCompetedata.value,
    combineProcedureList: store.state.inforReport?.combineProcedureList
  }).then((e) => {
    store.commit("inforReport/removeCombineProcedureList");
    store.commit("inforReport/removeKeepInforStatu", {});
    message.success(endCompetedata.value.goodOutput < productionNumberData.value.planOutput ? endCompetedata.value['isMissingNumber'] == 'y' ? "缺数上报成功" : '未完上报成功' : '完工上报成功');
    //退出完工调整
    visibleComplete.value = false
    setTimeout(() => {
      emit("switch", "workOrder", "")
    }, 1000);

  }, (e) => {
    visibleComplete.value = true
    return false;
  })
}, 2000)
//投料数不一致选择
const switchCanBeReceived = (type) => {
  if (radioChoose.value == type) {
    return
  }
  radioChoose.value = type
  endCompetedata.value['isWebShallPrevail'] = type
}
//没有生产的工单
const onErrorHandleOk = (status: 'cance' | 'complete') => {
  if (status === 'complete') {
    visibleError.value = false
    emit("switch", "workOrder", "")
  }
}
//备注信息弹框
const onMarkInfo = (status: 'cance' | 'complete') => {
  if (status === 'complete') {
    visiblemark.value = false
  }
}

//前置工单未完成
const onPreposeOk = (status: 'cance' | 'complete') => {
  if (status === 'cance') {
    visiblePrepose.value = false;
  } else {
    console.log(productionData.value.combineProcedureList, '-----');

    API.postMachineProductionMachineOperation({
      id: butOperationList.value[butCurOperation.value].id,
      workOrderId: showWorkId.value,
      countReportInVo: productUpLoadData.value,
      combineProcedureList: productionData.value.combineProcedureList
    }).then((e) => {
      //退出前置工单弹窗  
      visiblePrepose.value = false
      //开始生产 重新获取机台信息
      getCurWorkOrderLIst();
    }, (e) => {
      visiblePrepose.value = false;
      return false;
    })
  }
}

//开始调机确认
const onReceivingHandleOk = throttle((status: 'cance' | 'complete') => {
  if (status === 'cance') {
    visibleReceiving.value = false;
    visibleReceivStatu.value = false
    editdebugOutputAdjustment.value = 0
    editdebugGoodput.value = 0
  } else {
    productUpLoadData.value.debugOutputAdjustment = editdebugOutputAdjustment.value
    productUpLoadData.value.debugGoodOutputAdjustment = editdebugGoodput.value
    API.postMachineProductionMachineOperation({
      id: butOperationList.value[butCurOperation.value].id,
      workOrderId: showWorkId.value,
      countReportInVo: productUpLoadData.value,
      combineProcedureList: productionData.value.combineProcedureList
    }).then((e) => {
      //退出完工调整
      visibleReceiving.value = false
      editdebugGoodput.value = 0
      editdebugOutputAdjustment.value = 0
      visibleReceivStatu.value = false
      getProductionCountInfo(showWorkId.value)
      //获取新的按钮信息
      // getOperationList(showWorkId.value)
      //更新当前头部展示信息
      API.postMachineProductionGetProductionWorkOrderById({ id: showWorkId.value }).then((rep) => {
        productionData.value = rep;
      })

    }, (e) => {
      visibleReceiving.value = false;
      return false;
    })
  }
}, 2000)
//返回当前生产的工单
const resultCurOrder = () => {
  API.postMachineProductionCheckMachineIsProducing().then((rep) => {
    if (rep.producing) {
      showWorkId.value = rep.id;
      getCurWorkOrderLIst();
    } else {
      visibleError.value = true;
      curRunOrder.value = false;
      return false;
    }
  }, (e) => {
    if (e.code === '600010001') {
      visibleError.value = true;
      curRunOrder.value = false;
      return false;
    }
  })
}
//更新实时数
const updateRealData = (sign: string, newValue: number) => {
  if (sign == 'editdebugOutputAdjustment') {
    editdebugOutputAdjustment.value = newValue
    return
  }
  if (sign == 'editdebugGoodOutput') {
    editdebugGoodput.value = newValue
    return
  }
  productUpLoadData.value[sign] = newValue;
}
//材废更新
const wastUpdata = (data, newNum) => {
  productUpLoadData.value.materialBadDetailList = data
  if (newNum || newNum == 0) {
    productUpLoadData.value.materialBadOutput = newNum
    API.postMachineProductionCountReport(productUpLoadData.value);
  }
}

//机台操作  生产调机
const operationOnClick = throttle((cell: cellModel) => {
  if (cell.code === 1) {
    //进行操作
    API.postMachineProductionSecondaryConfirmation({ id: showWorkId.value }).then((rep) => {
      API.postMachineProductionMachineOperation({
        id: cell.id,
        workOrderId: showWorkId.value,
        countReportInVo: productUpLoadData.value,
        combineProcedureList: productionData.value.combineProcedureList
      }).then((rep) => {
        //开始生产 重新获取机台信息
        getCurWorkOrderLIst();
      })
    }, (e) => {
      if (e.code === '600010009') {
        visiblePrepose.value = true;
        return false;
      }
      return false
    })

  }
  else if (cell.code === 2 && needDebug.value) {
    //调机
    visibleReceiving.value = true;
    visibleReceivStatu.value = true
    editdebugOutputAdjustment.value = productUpLoadData.value.debugOutputAdjustment
    editdebugGoodput.value = productUpLoadData.value.debugGoodOutputAdjustment
  } else if (cell.code === butOperationList.value.length) {
    //性能最终调优
    productFinshUpLoadData.value = JSON.parse(JSON.stringify(productUpLoadData.value))
    visibleComplete.value = true
  } else {
    API.postMachineProductionMachineOperation({
      id: cell.id,
      workOrderId: showWorkId.value,
      countReportInVo: productUpLoadData.value,
      combineProcedureList: productionData.value.combineProcedureList
    }).then((rep) => {
      //获取新的按钮信息
      getOperationList(showWorkId.value)
      message.success('操作成功！');
    })
  }
}, 2000)
//获取当前生产的订单信息
const getCurWorkOrderLIst = () => {
  if (showWorkId.value) {
    //判断是否 有工单在生产，有工单就变更成返回
    API.postMachineProductionCheckMachineIsProducing().then((rep) => {
      //如果当前查看的工单是一致的，则 直接进入生产逻辑
      if (rep.producing && rep.id === showWorkId.value) {

        curRunOrder.value = true;
        //当前视图为机台正在生产界面
        curOrderStatus.value = true;
      } else {
        //这里特别说明，如果有工单在生产，则不展示按钮列表
        curRunOrder.value = !rep.producing;
        //当前视图为机台正在生产界面
        curOrderStatus.value = false;
      }
      //获取指定工单信息
      API.postMachineProductionGetProductionWorkOrderById({ id: showWorkId.value }).then((rep) => {
        showWorkId.value = rep.id;
        productionData.value = rep;
        updateCurPageInfo(rep.id)
      })

    })
  } else {

    //判断是否 有工单在生产，有工单就进入生产逻辑
    API.postMachineProductionGetCurProductionWorkOrderList().then((rep) => {
      curRunOrder.value = true;
      //当前视图为机台正在生产界面
      curOrderStatus.value = true;
      showWorkId.value = rep.id;
      productionData.value = rep;
      updateCurPageInfo(rep.id)
    },
      (e) => {
        if (e.code === '600010001') {
          visibleError.value = true;
          curRunOrder.value = false;
          return false;
        }
      }
    )
  }
}
//定时周期回调，包含生产时间计算、预计耗时、定时上报
const productionTime = () => {
  if (curOrderStatus.value) {
    if (productionNumberData.value.productionStartTime) {
      let new_date = new Date(); //新建一个日期对象，默认现在的时间
      //可以优化，不用每次都算
      let old_date = new Date(productionNumberData.value.productionStartTime); //设置过去的一个时间点，"yyyy-MM-dd HH:mm:ss"格式化日期
      let difftime = (new_date.getTime() - old_date.getTime()) / 1000; //计算时间差
      let hours = parseInt(difftime / 3600 + "");    // 小时 60*60 总小时数-过去的小时数=现在的小时数 
      let minutes = parseInt(difftime % 3600 / 60 + ""); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
      let seconds = parseInt(difftime % 60 + "");  // 以60秒为一整份 取余 剩下秒数
      productionTimeValue.value = compareNumber(hours) + ":" + compareNumber(minutes) + ":" + compareNumber(seconds)
    }
    //获取当前计数
    let machineNumber = props.realTimeData?.outCount || (startOutCount.value ? startOutCount.value : debugStartOutCount.value);
    //当前处于调机生产才进行计算 并且 mqtt有返回值
    if (needDebug.value&&butCurOperation.value === 1 && machineNumber && !visibleReceivStatu.value) {
      //调机增加自动计算
      productUpLoadData.value.debugOutputAdjustment = (machineNumber - debugStartOutCount.value)>=0?(machineNumber - debugStartOutCount.value):0
    }

    //预计耗时  投料数计算
    if (productionNumberData.value.planOutput && ((!needDebug.value|| curOperationOrder.value > 1) && curOperationOrder.value < butOperationList.value.length)) {
      //生产投料数
      let startOutValue = (machineNumber - productionNumberData.value.startProductionOutCount)
      // <0?0:(machineNumber - productionNumberData.value.startProductionOutCount)
      //正品生产数计算
      productUpLoadData.value.goodOutput = (startOutValue > 0 ? startOutValue : 0) - (productUpLoadData.value.workBadOutput || 0) +
        (productUpLoadData.value.goodOutputAdjustment || 0) +
        (productionData.value.isDebugGood ? (productUpLoadData.value.debugGoodOutputAdjustment || 0) : 0)
      //生产正品数小于调机正品数或零处理
      const DValue = productionData.value.isDebugGood ? productUpLoadData.value.debugGoodOutputAdjustment : 0
      if (productUpLoadData.value.goodOutput < DValue) {
        productUpLoadData.value.goodOutputAdjustment = productUpLoadData.value.goodOutputAdjustment + (DValue - productUpLoadData.value.goodOutput)
        productUpLoadData.value.goodOutput = DValue
      }
      //投料数=生产投料数+调机数
      allQuantity.value = startOutValue + productUpLoadData.value.debugOutputAdjustment
    }
    loopTime.value = loopTime.value + 1;
    if (loopTime.value > 30) {
      //每隔60秒 上传计数信息
      API.postMachineProductionCountReport(productUpLoadData.value).catch(err => {
        console.log(err, 'err');
        if (err.code == '600010001') {
          emit("switch", "workOrder", "")
        }
      });
      loopTime.value = 0;
    }
  }

}

return (_ctx: any,_cache: any) => {
  const _component_dvi = _resolveComponent("dvi")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!visibleComplete.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(jtabBar, {
              data: tabOperationList.value,
              select: _unref(activeKey),
              class: "jtabBarWidth flex flex-col flex-1",
              onSwitchTabs: showPageInfo
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dvi, {
                  class: "flex-1 flex flex-col justify-between infor",
                  style: {"background-color":"#ffffff"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bannerList).sonDataList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createVNode(JListInfo, {
                            class: "flex-1",
                            title: item.sonInfoTypeName,
                            listData: item.infoDataList,
                            onOnConfigFileds: ($event: any) => (onConfigFileds(item))
                          }, null, 8, ["title", "listData", "onOnConfigFileds"])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(JablilBtn, {
                          name: "查看图纸",
                          onClick: onShowImg,
                          style: _normalizeStyle({ marginLeft: _ctx.$px2rem('24px') }),
                          disable: _unref(productionData).imagesPath && _unref(productionData).imagesPath.length < 1
                        }, null, 8, ["style", "disable"]),
                        _createVNode(JablilBtn, {
                          name: "查看备注",
                          disable: !_unref(productionData).orderRemarks && !_unref(productionData).processRemarks
                && !_unref(productionData).processRoutingRemarks && !_unref(productionData).workOrderRemarks,
                          onClick: onShowMark,
                          "bg-color": '#1756BF'
                        }, null, 8, ["disable"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        (curOperationOrder.value > 0)
                          ? (_openBlock(), _createBlock(JablilBtn, {
                              key: 0,
                              name: "取消生产",
                              "bg-color": '#8C9EBC',
                              onClick: cancelProduction
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "select"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              ((butCurOperation.value === 1 || butCurOperation.value === 0) && needDebug.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (!_unref(productionData).isDebugGood)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "当前工序不支持调机正品"))
                      : _createCommentVNode("", true),
                    _createVNode(JText, {
                      name: "调机数",
                      onOnChangeValue: updateRealData,
                      sign: "debugOutputAdjustment",
                      "show-value": _unref(productUpLoadData).debugOutputAdjustment || 0
                    }, null, 8, ["show-value"]),
                    (_unref(productionData).isDebugGood)
                      ? (_openBlock(), _createBlock(JText, {
                          key: 1,
                          name: "调机正品数",
                          onOnChangeValue: updateRealData,
                          sign: "debugGoodOutputAdjustment",
                          maxValue: _unref(productUpLoadData).debugOutputAdjustment || 0,
                          value: _unref(productUpLoadData).debugGoodOutputAdjustment || 0,
                          "show-value": _unref(productUpLoadData).debugGoodOutputAdjustment || 0,
                          disable: false
                        }, null, 8, ["maxValue", "value", "show-value"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(JText, {
                      name: "计划产量",
                      sign: "planOutput",
                      "show-value": _unref(productionNumberData).planOutput || 0,
                      "tips-show": true,
                      "tips-value": _unref(productionData).coefficient
                    }, null, 8, ["show-value", "tips-value"]),
                    _createVNode(JText, {
                      name: "投料数 / 来料数",
                      preProcedureOutQty: _unref(productionNumberData).preProcedureOutQty || 0,
                      "show-value": (allQuantity.value + _unref(productUpLoadData).goodOutputAdjustment) || 0,
                      sign: "startProductionOutCount",
                      explain: `调机数 ${_unref(productUpLoadData).debugOutputAdjustment || 0}`
                    }, null, 8, ["preProcedureOutQty", "show-value", "explain"]),
                    _createVNode(JText2, {
                      name: "正品数",
                      onOnChangeValue: updateRealData,
                      sign: "goodOutputAdjustment",
                      value: _unref(productUpLoadData).goodOutputAdjustment || 0,
                      "show-value": _unref(productUpLoadData).goodOutput || 0,
                      disable: _unref(productionData).productionState == 'completed' ? true : false,
                      "min-show-value": _unref(productionData).isDebugGood ? _unref(productUpLoadData).debugGoodOutputAdjustment : 0,
                      explain: _unref(productionData).isDebugGood ? `调机正品数 ${_unref(productUpLoadData).debugGoodOutputAdjustment || 0}` : ''
                    }, null, 8, ["value", "show-value", "disable", "min-show-value", "explain"]),
                    _createVNode(JText, {
                      name: "工废数",
                      "show-value": _unref(productUpLoadData).workBadOutput || 0,
                      onOnChangeValue: updateRealData,
                      sign: "workBadOutput",
                      value: _unref(productUpLoadData).workBadOutput || 0,
                      "min-value": 0,
                      disable: _unref(productionData).productionState == 'completed' ? true : false,
                      iconShow: true,
                      "max-value": (allQuantity.value + _unref(productUpLoadData).goodOutputAdjustment
              - _unref(productUpLoadData).debugOutputAdjustment) > 0 ? (allQuantity.value + _unref(productUpLoadData).goodOutputAdjustment
                - _unref(productUpLoadData).debugOutputAdjustment) : 0
                    }, null, 8, ["show-value", "value", "disable", "max-value"]),
                    _createVNode(JText3, {
                      name: "材废数",
                      onWastUpdata: wastUpdata,
                      value: _unref(productUpLoadData).materialBadOutput,
                      wastList: _unref(productUpLoadData).materialBadDetailList
                    }, null, 8, ["value", "wastList"])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, " 上机人员：" + _toDisplayString(_unref(machineTeam)), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: "flex flex-col",
            style: _normalizeStyle({ width: _ctx.$px2rem('240px') })
          }, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(productionTimeValue)), 1),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(timeStep, {
                "button-data": butOperationList.value,
                "order-statu": _unref(curRunOrder),
                "order-step": curOperationOrder.value,
                "complete-order": _unref(productionData).productionState == 'completed'
              }, null, 8, ["button-data", "order-statu", "order-step", "complete-order"])
            ]),
            _createVNode(buttonStyle, {
              "complete-order": _unref(productionData).productionState == 'completed',
              "button-data": butOperationList.value,
              "order-statu": _unref(curRunOrder),
              onOnClick: _unref(operationOnClick),
              onBackOrder: resultCurOrder
            }, null, 8, ["complete-order", "button-data", "order-statu", "onOnClick"])
          ], 4)
        ]))
      : _createCommentVNode("", true),
    (visibleComplete.value)
      ? (_openBlock(), _createBlock(JCompleteReport, {
          key: 1,
          data: _unref(productFinshUpLoadData),
          planOutput: _unref(productionNumberData).planOutput || 0,
          recordGoodNum: _unref(productFinshUpLoadData).goodOutput || 0,
          goodOutput: _unref(productUpLoadData).goodOutput,
          productionData: _unref(productionData),
          onOnResultOperate: onHandleOk
        }, null, 8, ["data", "planOutput", "recordGoodNum", "goodOutput", "productionData"]))
      : _createCommentVNode("", true),
    (visibleConfigFiles.value)
      ? (_openBlock(), _createBlock(configFiles, {
          key: 2,
          visible: visibleConfigFiles.value,
          id: showConfigFilesId.value,
          title: showConfigFilesTitle.value,
          onResult: onCloseConfigFileds
        }, null, 8, ["visible", "id", "title"]))
      : _createCommentVNode("", true),
    _createVNode(MessageShow, {
      show: visibleError.value,
      title: "当前没有生产工单",
      detail: "请先前往工单选择任务进行生产",
      onOnResultOperate: onErrorHandleOk,
      hideCance: true,
      maskClosable: false
    }, null, 8, ["show"]),
    _createVNode(MessageShow, {
      show: visiblePrepose.value,
      title: "前置工单未完成",
      detail: "部分前置工单未完成，是否继续生产",
      onOnResultOperate: onPreposeOk,
      hideCance: false,
      maskClosable: false
    }, null, 8, ["show"]),
    _createVNode(MessageShow, {
      show: missReportComplete.value,
      title: "投料数不一致",
      detail: "当前投料数和设备记录投料数不一致,请确认投料数",
      onOnResultOperate: missComplete,
      hideCance: false,
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(titleRadio, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (switchCanBeReceived('y'))),
          name: '当前投料数',
          value: _unref(FeedingQuantity).webId || 0,
          "icon-show": true,
          "show-text": '当前投料数=正品数-调机正品数+工废数+调机数',
          "radio-choose": radioChoose.value == 'y'
        }, null, 8, ["value", "radio-choose"]),
        _createVNode(titleRadio, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (switchCanBeReceived('n'))),
          name: '设备记录投料数',
          value: _unref(FeedingQuantity).deviceId || 0,
          "radio-choose": radioChoose.value == 'n'
        }, null, 8, ["value", "radio-choose"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(MessageShow, {
      show: visibleReceiving.value,
      title: "接单调机",
      detail: "确认信息后将进入下一工序",
      onOnResultOperate: _unref(onReceivingHandleOk),
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(titleButton, {
          name: "调机",
          sign: "editdebugOutputAdjustment",
          value: editdebugOutputAdjustment.value || 0,
          onOnChangeValue: updateRealData,
          minValue: editdebugGoodput.value || 0
        }, null, 8, ["value", "minValue"]),
        (_unref(productionData).isDebugGood)
          ? (_openBlock(), _createBlock(titleButton, {
              key: 0,
              name: "调机正品",
              sign: "editdebugGoodOutput",
              value: editdebugGoodput.value || 0,
              onOnChangeValue: updateRealData,
              maxValue: editdebugOutputAdjustment.value || 0
            }, null, 8, ["value", "maxValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "onOnResultOperate"]),
    _createVNode(MessageShow, {
      show: visiblemark.value,
      title: "备注说明",
      onOnResultOperate: onMarkInfo,
      hideCance: true,
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          (_unref(productionData).orderRemarks)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, "订单备注：" + _toDisplayString(_unref(productionData).orderRemarks), 1))
            : _createCommentVNode("", true),
          (_unref(productionData).processRemarks)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, "工序备注：" + _toDisplayString(_unref(productionData).processRemarks), 1))
            : _createCommentVNode("", true),
          (_unref(productionData).processRoutingRemarks)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, "工艺备注：" + _toDisplayString(_unref(productionData).processRoutingRemarks), 1))
            : _createCommentVNode("", true),
          (_unref(productionData).workOrderRemarks)
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, "生产备注：" + _toDisplayString(_unref(productionData).workOrderRemarks), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(MessageShow, {
      show: cancelProductionShow.value,
      title: "取消生产",
      detail: "当前工单已开始正式生产是否取消生产？",
      btnCompleteName: "完工上报",
      btnCanceName: "取消生产",
      closable: true,
      onOnResultOperate: onCancelHandleOk,
      maskClosable: false
    }, null, 8, ["show"])
  ], 64))
}
}

})